// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"95c7b001","84":"3ec1ba9e","247":"5b9d13c9","309":"255c9efc","440":"1db0f50b","627":"6e9f2257","738":"40fd9176","834":"04bc20bd","923":"5a11318a"}[chunkId] + ".chunk.js";
};